import Card from "@mui/material/Card";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Logo from "assets/images/edushala.png";
import { useState, useEffect } from "react";
import { getCompany } from "services/companyService";
import { CircularProgress } from "@mui/material";

function Tables() {
  const token = localStorage.getItem("token");
  const [companyData, setCompanyData] = useState({
    name: "Edushala",
    logo: Logo,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    try {
      const response = await getCompany();
      if (response.success && response.data) {
        setCompanyData({
          name: response.data.name || "Edushala",
          logo: response.data.logo || Logo,
        });
      }
    } catch (error) {
      console.error("Failed to fetch company data:", error);
      // Use default values if fetch fails
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={6} display="flex" justifyContent="center" alignItems="center">
        <Card
          sx={{
            p: 5,
            textAlign: "center",
            width: "100%",
            boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
            borderRadius: "20px",
            background: "linear-gradient(135deg, #f5f9ff, #ffffff)",
          }}
        >
          {loading ? (
            <ArgonBox display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress color="info" />
            </ArgonBox>
          ) : (
            <>
              {/* Logo */}
              <ArgonBox display="flex" justifyContent="center">
                <img
                  src={companyData.logo}
                  alt={`${companyData.name} Logo`}
                  style={{ width: "140px", height: "140px", objectFit: "contain" }}
                />
              </ArgonBox>

              {/* Heading */}
              <ArgonTypography variant="h3" fontWeight="bold" color="primary" gutterBottom>
                Welcome to <span style={{ color: "#2196f3" }}>{companyData.name}</span> Dashboard
              </ArgonTypography>

              <ArgonTypography variant="body1" color="text" mb={4}>
                Manage your data, track progress, and explore features with ease 🚀
              </ArgonTypography>
            </>
          )}
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
